import { Directive, inject } from '@angular/core';
import { IonTextarea } from '@ionic/angular';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'ion-textarea',
    standalone: false
})
export class IonicTextareaDirective {
  private readonly textarea = inject(IonTextarea);

  constructor() {
    this.textarea.labelPlacement = 'floating';
    this.textarea.fill = 'outline';
    this.textarea.rows = 4;
    this.textarea.mode = 'md';
  }
}
